import { render, staticRenderFns } from "./NoticeQrCode.vue?vue&type=template&id=bbe23d5a&scoped=true"
import script from "./NoticeQrCode.vue?vue&type=script&lang=js"
export * from "./NoticeQrCode.vue?vue&type=script&lang=js"
import style0 from "./NoticeQrCode.vue?vue&type=style&index=0&id=bbe23d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe23d5a",
  null
  
)

export default component.exports